
<template>
  <transition name="xm-overlay">
    <div :class="'xm-overlay ' + (transparent ? 'transparent' : '')"
         v-if="show"
         @click="click && click()">
      <div class="inner"
           v-bind:style="{ opacity: opacity }">
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'xm-overlay',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    click: {
      type: Function,
      default: undefined
    },
    transparent: {
      type: Boolean,
      default: false
    },
    opacity: {
      type: Number,
      default: 1
    }
  },
  watch: {
    show(val) {
    }
  }
};
</script>

<style lang="less" scoped>
.xm-overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  transition: opacity .3s;
  opacity: 1;

  .inner {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
  }
  &.transparent .inner {
    background-color: transparent;
  }

  &.overlay-enter,
  &.overlay-leave-active {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Overlay.vue